import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getPost } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    getPost(slug).then(setPost).catch((e) => setErr(e?.response?.data?.detail || "Not found"));
  }, [slug]);

  if (err) return <main className="pt-32 pb-24 max-w-3xl mx-auto px-4"><p className="text-slate-600">{err}</p><Link className="mt-4 inline-block text-emerald-800" to="/blog">← Back to journal</Link></main>;
  if (!post) return <main className="pt-32 pb-24 max-w-3xl mx-auto px-4"><p className="text-slate-500">Loading…</p></main>;

  return (
    <main data-testid="blog-post-page" className="pt-24 md:pt-32 pb-24">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="chapter-index text-emerald-700">{post.category} · {post.read_minutes} min read</p>
        <h1 className="font-display text-4xl md:text-6xl leading-[1] mt-3">{post.title}</h1>
        <p className="mt-4 text-slate-500 text-sm">By {post.author} · {new Date(post.published_at).toDateString()}</p>
      </section>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <div className="rounded-3xl overflow-hidden aspect-[16/8]"><img src={post.cover_image} alt="" className="w-full h-full object-cover"/></div>
      </div>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 prose prose-slate">
        <p className="text-lg text-slate-700 leading-relaxed whitespace-pre-line">{post.content}</p>
        {post.is_demo && <p className="mt-10 text-xs text-slate-500">Editorial demo content. Real published guidance will replace this post-launch.</p>}
        <div className="mt-12">
          <Link to="/blog" className="text-emerald-800 border-b border-emerald-800 pb-1 text-sm">← Back to journal</Link>
        </div>
      </article>
    </main>
  );
}
